module.exports = __webpack_public_path__ + "img/crm.8625979d.png";